// libs
import React from 'react';

// types
import { IWidget } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/types';

// styles
import { PlainWidgetContainer, InfoContent, InfoTitle } from './styles';

// styles
import sanitizeHTML from 'shared/helpers/utils/sanitizeHTML';

interface IPlaneWidget {
  widget: IWidget;
  showTitle: boolean;
  className?: string;
}
function PlainWidget({ widget, showTitle, className }: IPlaneWidget) {
  return (
    <PlainWidgetContainer className={className}>
      {showTitle && <InfoTitle>{widget.title}</InfoTitle>}
      <InfoContent dangerouslySetInnerHTML={{ __html: sanitizeHTML(widget.value) }} data-test="info-value" />
    </PlainWidgetContainer>
  );
}

export default PlainWidget;
